export const classes = {
  section: 'mb-4',
  list: 'w-full',
};
